// Within this many pixels of the newest message the reader counts as at the bottom.
const AT_BOTTOM_TOLERANCE = 2

/**
 * Where a reversed timeline (scrollTop 0 is the newest message) should scroll
 * after its viewport resized, or null to leave it. At the bottom the browser
 * already keeps the newest message in view, so shifting it would hide it.
 */
export function scrollTopAfterResize({
	scrollTop,
	prevHeight,
	newHeight,
}: {
	scrollTop: number
	prevHeight: number
	newHeight: number
}): number | null {
	if (!prevHeight || prevHeight === newHeight) return null
	if (Math.abs(scrollTop) <= AT_BOTTOM_TOLERANCE) return null
	return scrollTop - (newHeight - prevHeight)
}
